import { QueryClient } from "@tanstack/react-query";

// Single shared QueryClient. Defaults tuned for an admin panel:
// - Don't refetch on focus (admin panel has long sessions, refetching is noisy).
// - 30s stale time (admin data doesn't change every second).
// - 1 retry on transient failures, then surface the error.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
